<template>
  <div class="box">
    <my-title size="6">Rechten</my-title>

    <div v-for="scope in scopes"
      v-show="!isHidden(scope.id)"
      :key="scope.id"
      class="notification">

      <scope
        :user="user"
        :scope="scope"
        :myScopes="myScopes"
        :parentSelected="true"></scope>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MyTitle from '@/components/modules/Title'
import Scope from '@/components/scopes/Scope'

export default {
  components: {
    Scope,
    MyTitle
  },
  props: [
    'user',
    'myScopes'
  ],
  computed: {
    ...mapGetters({
      scopes: 'scopes/scopes'
    })
  },
  methods: {
    adminIsSet (myId) {
      if (myId === 1) {
        return false
      }

      return this.selected.includes(1)
    },
    isHidden (scopeId) {
      return [10, 2, 3, 5].includes(scopeId)
    }
  }
}
</script>

<style scoped>
  .sub-scope {
    padding-left: 30px;
  }
</style>
